// extracted by mini-css-extract-plugin
export default {"container":"styles_container__wBtgU","contato":"styles_contato__UivcU","inputList":"styles_inputList__VnkZn"};